import React, { Dispatch, SetStateAction } from "react";
import { Flex, Text, TouchableOpacity } from "@atoms";
import { IntentCategoryEnum } from "@types";

// == Types ================================================================

interface IProps {
  activeFundraiserTab: IntentCategoryEnum;
  setFundraiserTab: Dispatch<SetStateAction<IntentCategoryEnum>>;
}

// == Constants ============================================================

// == Component ============================================================

export default function FundsPageFundraiserTabs({ activeFundraiserTab, setFundraiserTab }: IProps) {
  return (
    <Flex width="100%">
      <TouchableOpacity
        borderBottom={
          activeFundraiserTab === IntentCategoryEnum.ALL ? "fundsTabActive" : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setFundraiserTab(IntentCategoryEnum.ALL)}
      >
        <Text color={activeFundraiserTab === IntentCategoryEnum.ALL ? "#2C9895" : ""}>All</Text>
      </TouchableOpacity>
      <TouchableOpacity
        borderBottom={
          activeFundraiserTab === IntentCategoryEnum.SHOPPING
            ? "fundsTabActive"
            : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setFundraiserTab(IntentCategoryEnum.SHOPPING)}
      >
        <Text color={activeFundraiserTab === IntentCategoryEnum.SHOPPING ? "#2C9895" : ""}>
          Shopping
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        borderBottom={
          activeFundraiserTab === IntentCategoryEnum.DONATION
            ? "fundsTabActive"
            : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setFundraiserTab(IntentCategoryEnum.DONATION)}
      >
        <Text color={activeFundraiserTab === IntentCategoryEnum.DONATION ? "#2C9895" : ""}>
          Donation
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        borderBottom={
          activeFundraiserTab === IntentCategoryEnum.BONUS ? "fundsTabActive" : "fundsTabInActive"
        }
        containerProps={{ style: { width: "100%" } }}
        py={3}
        textAlign="center"
        width={1}
        onTouch={() => setFundraiserTab(IntentCategoryEnum.BONUS)}
      >
        <Text color={activeFundraiserTab === IntentCategoryEnum.BONUS ? "#2C9895" : ""}>Bonus</Text>
      </TouchableOpacity>
    </Flex>
  );
}

// == Styles ===============================================================
